


const body = document.querySelector('body');
if(body.classList.contains('template-collection')){
  document.addEventListener("DOMContentLoaded", function() {
      document.querySelector(".first-grid-changer").addEventListener("click", function() {
        this.classList.add("active");
        document.querySelector(".second-grid-changer").classList.remove("active");
        var elements = document.querySelectorAll("#product-grid.product-grid");
        for (var i = 0; i < elements.length; i++) {
          elements[i].classList.add("grid--1-col-tablet-down");
          elements[i].classList.remove("grid--2-col-tablet-down");
        }
      });

      // Function to remove class .small--one-full when clicking on .second-grid-changer
      document.querySelector(".second-grid-changer").addEventListener("click", function() {
         this.classList.add("active");
        document.querySelector(".first-grid-changer").classList.remove("active");
        var elements = document.querySelectorAll("#product-grid.product-grid");
        for (var i = 0; i < elements.length; i++) {
          elements[i].classList.remove("grid--1-col-tablet-down");
          elements[i].classList.add("grid--2-col-tablet-down");
        }
      });
    });
}


if(body.classList.contains == 'template-product'){
  const headings = document.querySelectorAll('.tabs-heading');
        // Get all the p elements with class "tabs-content"
        const contents = document.querySelectorAll('.tabs-content');

        // Add click event listeners to each h1 element
        headings.forEach((heading) => {
            heading.addEventListener('click', () => {
                // Remove the "active" class from all p elements
                contents.forEach((content) => {
                    content.classList.remove('active');
                });

                // Get the ID of the clicked h1 element
                const targetId = heading.getAttribute('id');

                // Find the corresponding p element with the same ID and add the "active" class
                const targetContent = document.getElementById(targetId);
                targetContent.classList.add('active');
            });
        });
}

// Custom Flow


window.addEventListener("load", function() {
    var radioInputs = document.querySelectorAll('input[type="radio"][name="Type"]');
    var sizeRadioInputs = document.querySelectorAll('input[type="radio"][name="Size"]');
    var customSizeInput = document.querySelector('input[type="radio"][value="Custom"]');
    var addOnOption = document.querySelector('.custom_size_option_addon');
    var addOnOptionInputs = document.querySelectorAll('.custom_size_option_addon input');
    var sizeFieldset = document.querySelector('input[type="radio"][name="Size"]')?.closest('fieldset');
    var addToCartButton = document.querySelector('button.product-form__submit');

    // Initial setup
    addOnOptionInputs.forEach(function(input) {
        input.disabled = true;
    });

    // Disable "Add to Cart" button initially if custom size input is selected
    function toggleAddToCartButton() {
        var allInputsHaveValue = Array.from(document.querySelectorAll('.custom_size_option_addon_input input'))
                                    .every(input => input.value.trim() !== '');
        addToCartButton.disabled = !allInputsHaveValue;
    }

    // Event listener for size radio inputs
    sizeRadioInputs.forEach(function(input) {
        input.addEventListener('change', function() {
            if (this.value === "Custom") {
                addOnOption.style.display = 'block';
                addOnOptionInputs.forEach(function(input) {
                    input.disabled = false;
                });
                toggleAddToCartButton();
            } else {
                addOnOption.style.display = 'none';
                addOnOptionInputs.forEach(function(input) {
                    input.disabled = true;
                    input.value = '';
                });
                addToCartButton.disabled = false;
            }
        });
    });

    // Function to update based on "Type" selection
    function updateSizeFieldset() {
        var selectedValue = document.querySelector('input[type="radio"][name="Type"]:checked')?.value;
        if (selectedValue === "Unstitched") {
            addOnOptionInputs.forEach(function(input) {
                input.disabled = true;
            });
            if (sizeRadioInputs.length > 0) {
                sizeRadioInputs[0].click();
                sizeFieldset.style.display = 'none';
            }
            addOnOption.style.display = 'none';
            addToCartButton.disabled = false;
        } else {
            if (sizeRadioInputs.length > 0) {
                sizeRadioInputs[1]?.click();
                sizeRadioInputs.forEach(function(input) {
                    input.classList.remove('disabled');
                });
                sizeFieldset.style.display = 'block';
            }
        }
    }

    // Initial call to update the size fieldset
    updateSizeFieldset();

    // Event listeners for Type radio inputs
    radioInputs.forEach(function(radio) {
        radio.addEventListener("change", updateSizeFieldset);
        radio.addEventListener("click", function() {
            addOnOption.style.display = 'none';
            addOnOptionInputs.forEach(input => {
                input.value = '';
            });
            addToCartButton.disabled = false;
        });
    });

    // Clean size radio behavior
    if (sizeRadioInputs.length > 0) {
        sizeRadioInputs.forEach(function(radio, index) {
            if (index !== sizeRadioInputs.length - 1) {
                radio.addEventListener("click", function() {
                    addOnOption.style.display = "none";
                    addOnOptionInputs.forEach(input => {
                        input.value = '';
                    });
                    addToCartButton.disabled = false;
                });
            }
        });
    }

    // Custom size input handling
    if (customSizeInput) {
        customSizeInput.addEventListener('click', function() {
            addOnOption.style.display = "block";
            addOnOptionInputs.forEach(function(input) {
                input.disabled = false;
            });

            toggleAddToCartButton();

            document.querySelectorAll('.custom_size_option_addon_input input').forEach(function(input) {
                input.addEventListener('input', toggleAddToCartButton);
            });
        });
    }

    // ✅ Auto-select Custom if it's the first variant
    if (sizeRadioInputs.length > 0 && sizeRadioInputs[0].value === "Custom") {
        sizeRadioInputs[0].click(); // Select first size option
        addOnOption.style.display = 'block';
        addOnOptionInputs.forEach(function(input) {
            input.disabled = false;
        });
        toggleAddToCartButton();
    }
});






